import axios from 'axios'
import store from '@/store'
import { vm } from '@/main'
import Vue from 'vue'
const serverIp = 'll-pro.liveabc.com/'
const appPath = 'api'
export const apiPath = 'https://' + serverIp + appPath
const api = axios.create({
  baseURL: apiPath,
  timeout: 60000,
  headers: {
    'access-control-allow-origin': '*',
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use((config) => {
  config.headers.Authorization = 'Bearer ' + store.state.auth.user.token
  if (config.headers.showLoading !== false) {
    store.commit('isLoading', true)
  }
  return config
}, (error) => {
  return Promise.reject(error)
})

api.interceptors.response.use((response) => {
  store.commit('isLoading', false)
  return response
}, (error) => {
  store.commit('isLoading', false)
  if (error.response && error.response.data.code) {
    const errorCode = error.response.data.code
    switch (errorCode) {
      case 1001:
        console.error('登入資訊錯誤。')
        vm.$swal({
          title: '登入失敗',
          text: '使用者名稱或密碼錯誤。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1002:
        console.error('帳號過期。')
        vm.$swal({
          title: '登入失敗',
          text: '課程已結束，如有問題請來信客服信箱 （livelearningpro@liveabc.com），將有專人為您服務，謝謝。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1003:
        console.error('E-mail 必須是有效的 E-mail。')
        vm.$swal({
          title: '登入失敗',
          text: 'E-mail 必須是有效的 E-mail。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1004:
        console.error('密碼不能留空。')
        vm.$swal({
          title: '登入失敗',
          text: '密碼不能留空。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1101:
        console.error('忘記密碼查無帳號')
        vm.$swal({
          title: '找不到該 E-mail 對應的使用者。',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1102:
        console.error('Email為空或格式錯誤')
        vm.$swal({
          title: '請輸入有效的電子信箱',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1201:
        console.error('查無此帳號')
        vm.$swal({
          title: '查無此帳號',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1202:
        console.error('密碼請設置8-20碼英數混合密碼（英文字母需區分大小寫）')
        vm.$swal({
          title: '密碼請設置8-20碼英數混合密碼（英文字母需區分大小寫）',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1203:
        console.error('舊密碼輸入錯誤')
        vm.$swal({
          title: '舊密碼輸入錯誤',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 1204:
        vm.$swal({
          title: '連結失效，請至忘記密碼重新發送通知信',
          icon: 'info',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 3001:
        console.error('未登入')
        store.commit('logout')
        vm.$router.push({ name: 'Login' })
        break
      case 3002:
        Vue.swal({
          title: '請先完成學前測驗',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: '確定',
          cancelButtonText: '返回'
        }).then((isConfirm) => {
          if (isConfirm.value === true) {
            vm.$router.push({ name: 'Exam-area' })
          }
        })
        break
      case 3003:
        Vue.swal({
          title: '分類下架或找不到分類',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 3004:
        Vue.swal({
          title: '課程下架或找不到課程',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 3501:
        console.error('無資料。')
        break
      case 5001:
        console.error('企業不存在。')
        Vue.$swal({
          title: '企業不存在。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 5301:
        console.error('班級不存在。')
        Vue.$swal({
          title: '班級不存在。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      case 5501:
        console.error('學生不存在。')
        Vue.$swal({
          title: '學生不存在。',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        break
      default:
        console.error('Unexpected error:', errorCode)
        vm.swal({
          title: '發生錯誤',
          icon: 'error',
          confirmButtonText: '返回'
        }).then((isConfirm) => {
          if (isConfirm.value === true) {
            vm.$router.push({ name: 'Home' })
          }
        })
    }
  } else {
    console.error('Network error:', error.message)
  }
  // if (error.response && error.response.status === 401 && error.response.data.message !== 'PLEASE_FINISH_PRETEST') {
  //   store.commit('logout')
  //   vm.$router.push({ name: 'Login' })
  // } else if (error.response.data) {
  //   store.commit('isLoading', false)
  //   store.commit('setErrorMessage', error.response.data.Message)
  //   if (error.response.data.message === 'PLEASE_FINISH_PRETEST') {
  //     Vue.swal({
  //       title: '請先完成學前測驗',
  //       icon: 'error',
  //       showCancelButton: true,
  //       confirmButtonText: '確定',
  //       cancelButtonText: '返回'
  //     }).then((isConfirm) => {
  //       if (isConfirm.value === true) {
  //         vm.$router.push({ nam54e: 'Exam-area' })
  //       }
  //     })
  //   } else if (error.response && error.response.status === 422) {
  //     Vue.swal({
  //       title: error.response.data.errors.content,
  //       icon: 'info',
  //       confirmButtonText: '返回'
  //     })
  //   } else {
  //     Vue.swal({
  //       title: '發生錯誤',
  //       icon: 'error',
  //       confirmButtonText: '返回'
  //     }).then((isConfirm) => {
  //       if (isConfirm.value === true) {
  //         vm.$router.push({ name: 'Home' })
  //       }
  //     })
  //   }
  // } else {
  //   store.commit('setErrorMessage', error.message)
  // }
  return Promise.reject(error)
})

export default api
